import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SHIPPING_BOX_SAVE_MOCKS, SHIPPING_BOXES_MOCKS, SHIPPING_QUOTE_MOCKS } from '@shared/mocks/shipping.mock';

import {
  ShippingBoxesResponse,
  ShippingBoxRequest,
  ShippingBoxSaveResponse,
  ShippingQuoteRequest,
  ShippingQuoteResponse,
  UpdateShippingBoxRequest,
} from './interfaces/shipping.interfaces';

import { HttpInterceptor } from '@interceptors/http/http.interceptor';

@Injectable({ providedIn: 'root' })
export class ShippingService {
  private readonly http = inject(HttpInterceptor);
  private readonly apiUrl = 'shipping';

  /** POST /shipping/quote -> costo de despacho con Chilexpress para la dirección y el carrito. */
  public quoteShipping(dto: ShippingQuoteRequest): Observable<ShippingQuoteResponse> {
    return this.http.post(`${this.apiUrl}/quote`, dto, SHIPPING_QUOTE_MOCKS);
  }

  /** GET /shipping/boxes -> cajas activas e inactivas. */
  public getShippingBoxes(): Observable<ShippingBoxesResponse> {
    return this.http.get(`${this.apiUrl}/boxes`, SHIPPING_BOXES_MOCKS);
  }

  /** POST /shipping/boxes -> crea una caja activa. */
  public createShippingBox(dto: ShippingBoxRequest): Observable<ShippingBoxSaveResponse> {
    return this.http.post(`${this.apiUrl}/boxes`, dto, SHIPPING_BOX_SAVE_MOCKS);
  }

  /** PATCH /shipping/boxes/:id -> edita o activa/desactiva una caja. */
  public updateShippingBox(id: string, dto: UpdateShippingBoxRequest): Observable<ShippingBoxSaveResponse> {
    return this.http.patch(`${this.apiUrl}/boxes/${id}`, dto, SHIPPING_BOX_SAVE_MOCKS);
  }
}
